/* פעולות: מקור (עו"ש/אשראי), החרגה, ממתין, וכפילויות ודאיות */
import { S } from './state.js';
import { todayISO, iso10, absAmt } from '../lib/format.js';
import { isSavingTx } from './savings.js';

/** חיוב של חברת כרטיסי אשראי. מילים קצרות (כאל, מקס) רק כמילה שלמה, אחרת "מיכאל" נתפס */
export const CARD_RX = /ישראכרט|(^|[^א-ת])(כאל|קאל|מקס)([^א-ת]|$)|\bMAX\b|לאומי ?קארד|אמריקן ?אקספרס|דיינרס|(כרטיס|כרטיסי|חיוב|חיובי) ?אשראי/i;

export function getTxSrc(t) {
  return t && t.source === 'credit' ? 'credit' : 'cash';
}
export const srcIcon = (s) => (s === 'credit' ? '💳' : '🏦');
export const srcLabel = (s) => (s === 'credit' ? 'אשראי' : 'עו"ש');

/** מוחרגת מסיכומי ההוצאות: סומנה ידנית, או העברה לחיסכון (שהיא לא הוצאה) */
export function isExcluded(t) {
  if (!t) return false;
  if (isSavingTx(t)) return true;
  return t.excluded === true;
}

/** חיוב עו"ש שתאריכו עתידי: מוצג, אבל לא נספר עד שהוא יורד.
    עסקת אשראי מדוח שייכת לתקופת החיוב שלה גם כשהתאריך עתידי (תשלומים מתוארכים ליום החיוב) */
export function isPending(t) {
  if (!t || !t.date) return false;
  if (getTxSrc(t) === 'credit') return false;
  return iso10(t.date) > todayISO();
}

export function filterActive(txs) {
  return txs.filter((t) => !isExcluded(t) && !isPending(t));
}

export function pendingSum(txs) {
  return (txs || []).filter((t) => !isExcluded(t) && isPending(t) && t.type === 'expense').reduce((s, t) => s + absAmt(t), 0);
}

export function sumBy(txs, type) {
  return txs.filter((t) => t.type === type).reduce((s, t) => s + Number(t.amount || 0), 0);
}

export function txOfPeriod(k) {
  return S.tx.filter((t) => t.month === k);
}

/** שורת חיוב הכרטיס בעו"ש (הסכום המרוכז, לא עסקה בכרטיס) */
export function isCardChargeRow(t) {
  return t && t.type === 'expense' && getTxSrc(t) !== 'credit' && CARD_RX.test(t.description || '') &&
    (absAmt(t) >= 500 || t.excluded === true);
}

/** התקופה שאליה שויכה פעולה. בלי שיוך: לפי התאריך */
export function txPeriodOf(t, getKey) {
  return t.month || getKey(new Date(iso10(t.date) + 'T12:00:00'));
}

/* ── כפילויות ודאיות: זהות בכל השדות. קנייה כפולה באותו יום היא מקרה אמיתי, ולכן אפשר לאשר ── */
export function findDupTx() {
  const ok = new Set((S.set.dupOk || []).map(String));
  const seen = {}, dups = [];
  S.tx.forEach((t) => {
    if (ok.has(String(t.id))) return;
    const k = [iso10(t.date), t.description || '', Math.round(absAmt(t) * 100), t.type || 'expense', t.ref || ''].join('|');
    if (seen[k]) dups.push({ keep: seen[k], extra: t });
    else seen[k] = t;
  });
  return dups;
}
